// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__13HSN","row":"Node_row__kqRhq","label":"Node_label__1RYbB","footer":"Node_footer__2apPp"};